import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Button, List, Modal, message, Icon, Switch, InputItem, Toast, TextareaItem, ImagePicker } from 'antd-mobile';
import videojs from 'video.js';
import { Vh5Video } from '../../../components/videoPaler';
import { browserToWxAuth } from '../../../utils/weixin';
import { API } from '../../../env';
import { getQueryString } from '../../../utils/common';
import 'video.js/dist/video-js.min.css';
import './index.scss';
const mapStateToProps = state => {
	return {
		siteSwitch: state.AdminReducers.siteSwitch
	};
};
function CopyrightVideo(props) {
	let history = useHistory();
	const mapState = useCallback(mapStateToProps, []);
	const { siteSwitch } = useMappedState(mapState);
	let dispatch = useDispatch();
	let [playerOptions, setPlayerOptions] = useState({});
	function onPlayer() {
		const videoJsOptions = {
			autoplay: true,
			controls: true,
			fluid: true,
			controlBar: {
				fullscreenToggle: false
			},
			sources: [
				{
					// src: 'https://img-fat.vphotos.cn/bucket-fat/576CEEEFAB843BA6646B0E8738F736C9/postp/logodouble/vbox7104_3b9c8a73_s_cMVI_0203-xhp_0-001.mp4',
					// src: 'https://bkwft01.oss-cn-hangzhou.aliyuncs.com/upload/album/banner/t8gSmggITqRMDldDAwBh7Ju09KDe138O.mp4',
					src: 'https://voss-fat.vphotos.cn/a/dc842a/2e4b/4ahtPvA0/vbox0000_nocr_l_cMVI_270961-000.mp4',
					// src: 'https://voss-fat.vphotos.cn/a/1dadda/2e4b/4ahsi86w/vbox0000_nocr_l_cMVI_270817-000.mp4',
					type: 'video/mp4'
				}
			],
			closeCallback: () => {
				setPlayerOptions({});
			}
		};
		setPlayerOptions(videoJsOptions);
	}
	function onOpenWX() {
		browserToWxAuth({
			appid: API.APPID,
			scopeType: 'snsapi_userinfo',
			redirectUrl: encodeURIComponent('https://' + API.DOMAIN + '/vpmobile/copyright/home') + '?callbackcode=wx',
			state: 'STATE'
		});
		// let wxUrl = "https://open.weixin.qq.com/connect/qrconnect?appid="+API.APPID+"&redirect_uri="+encodeURIComponent("https://"+API.DOMAIN+"/vpmobile/copyright/home")+"&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
		// console.log (wxUrl);
		// alert(wxUrl);
		// window.location.href=wxUrl;
		// window.location.href = "weixin://dl/businessWebview/link/?appid=wx707c5fa91ef0a58c&url=http://www.baidu.com";
	}
	useEffect(() => {
		let code = null;
		if ((code = getQueryString('callbackcode'))) {
			alert(code);
		}
	});
	return (
		<div className="copyright copyright-video">
			<Button onClick={onPlayer}>播放</Button>
			<Button onClick={onOpenWX}>打开微信</Button>
			{playerOptions && playerOptions.sources ? <Vh5Video {...playerOptions} /> : ''}
		</div>
	);
}
export { CopyrightVideo };
